module.exports = "/images/stamp.png?b6f30c0ab844efc017f1d209a36898bb";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stamp.png
// module id = n353
// module chunks = 0